module.exports = __webpack_public_path__ + "themes/non-default/vennProvidedLogoGreyscale.5c992fb06836e310a19ceaf6952848fc.png";